module.exports = __webpack_public_path__ + "static/projects-illustration-1218890aecbf799a66d45ba75d00234e.svg";